import { combineReducers } from "redux";
import notificationsReducer from "./notifications";
import alertsReducer from "./alerts";
import capturesReducer from "./captures";
import devicesReducer from "./devicesSlice";
import organizationsReducer from "./organizations";
import schedulesReducer from "./schedules";
import analyticsReducer from "./analytics";
import commandReducer from "./command";
import { configureStore, Action, ThunkAction } from "@reduxjs/toolkit";
import { deviceApi } from "../actions/devicesInQuery";
import { trapSiteApi } from "../actions/trapsiteInQuery";
import { alertApi } from "../actions/alertsInQuery";
import alertsSlice from "./alertsSlice";
import catalogFilterReducer from "./catalogFilterSlice";
import { catalogApi } from "../actions/catalogInQuery";

export const reducers = combineReducers({
  [deviceApi.reducerPath]: deviceApi.reducer,
  [trapSiteApi.reducerPath]: trapSiteApi.reducer,
  [alertApi.reducerPath]: alertApi.reducer,
  [catalogApi.reducerPath]: catalogApi.reducer,
  notifications: notificationsReducer,
  alerts: alertsReducer,
  captures: capturesReducer,
  devices: devicesReducer,
  organizations: organizationsReducer,
  schedules: schedulesReducer,
  analytics: analyticsReducer,
  command: commandReducer,
  alertsSlice: alertsSlice,
  catalogFilter: catalogFilterReducer,
});

export const store = configureStore({
  reducer: reducers,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(deviceApi.middleware)
      .concat(trapSiteApi.middleware)
      .concat(alertApi.middleware)
      .concat(catalogApi.middleware),
  devTools:
    process.env.REACT_APP_ENV !== "production"
      ? {
          trace: true,
          traceLimit: 25,
        }
      : false,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
